import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminSecurity = ({ headers }) => {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const inputCls =
    "w-full bg-transparent border-b border-[#C29B62]/40 focus:border-[#1C3829] outline-none py-3 text-base font-light placeholder:text-[#1A1A1A]/35 transition-colors";
  const labelCls = "block text-xs uppercase tracking-[0.2em] text-[#1A1A1A]/50 mb-1";

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) {
      toast.error("La nuova password deve avere almeno 8 caratteri");
      return;
    }
    if (form.new_password !== form.confirm) {
      toast.error("Le nuove password non coincidono");
      return;
    }
    setSaving(true);
    try {
      await axios.post(
        `${API}/auth/change-password`,
        { current_password: form.current_password, new_password: form.new_password },
        { headers: headers() }
      );
      toast.success("Password aggiornata");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Errore durante l'aggiornamento");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid="admin-security-section" className="border border-[#C29B62]/25 bg-white/60 p-8">
      <div className="flex items-center gap-3">
        <KeyRound className="w-4 h-4 text-[#C29B62]" />
        <h2 className="text-2xl font-light text-[#1C3829] font-serif-display">Cambia password</h2>
      </div>
      <form onSubmit={submit} className="mt-6 grid grid-cols-1 md:grid-cols-4 gap-6 items-end" data-testid="admin-password-form">
        <div>
          <label className={labelCls}>Password attuale</label>
          <input data-testid="admin-current-password" type="password" required className={inputCls} value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} />
        </div>
        <div>
          <label className={labelCls}>Nuova password</label>
          <input data-testid="admin-new-password" type="password" required minLength={8} className={inputCls} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} />
        </div>
        <div>
          <label className={labelCls}>Conferma nuova password</label>
          <input data-testid="admin-confirm-password" type="password" required minLength={8} className={inputCls} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
        </div>
        <button
          data-testid="admin-password-submit"
          type="submit"
          disabled={saving}
          className="bg-[#1C3829] text-[#F7F5F0] text-xs uppercase tracking-[0.25em] px-6 py-3.5 hover:text-[#C29B62] transition-colors disabled:opacity-40"
        >
          Aggiorna
        </button>
      </form>
    </section>
  );
};
